module.exports = __webpack_public_path__ + "img/logo_01.23ad7425.png";